<script>
import {mapState} from "vuex";

export default {
    name: "instagramOverview",
     data () {
        return {
            filterDays: 0,
            performanceData: [
                {
                    label: 'Engagement',
                    name: 'engagement',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Impressions',
                    name: 'impressions',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Reach',
                    name: 'reach',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Likes',
                    name: 'likes',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Avg. reach per post',
                    name: 'average_reach_per_post',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Avg. engagement rate per post',
                    name: 'average_engagement_rate_per_post',
                    value: '',
                    trend: ''
                },
                {
                    label: 'New followers',
                    name: 'new_followers',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Posts & Stories',
                    name: 'posts_count',
                    value: '',
                    trend: ''
                },
            ],
            averagePerformanceData: [
                {
                    label: 'Avg. daily new followers',
                    name: 'new_followers',
                    value: '',
                    series: [
                        {
                            name: '',
                            data: []
                        }
                    ]
                },
                {
                    label: 'Avg. daily engagement',
                    name: 'engagement',
                    value: '',
                    series: [
                        {
                            name: '',
                            data: []
                        }
                    ]
                },
                {
                    label: 'Avg. daily impressions',
                    name: 'impressions',
                    value: '',
                    series: [
                        {
                            data: []
                        }
                    ]
                }
            ],
            chartOptions: {
                chart: {
                    height: 200,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "70%"
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    type: "datetime",
                    labels: {
                        show: false,
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                        formatter: function(val) {
                            return val.toFixed(0)
                        }
                    }
                },
                colors: ["#01baf1", "#f156e3"],
                legend: {
                    position: "bottom"
                },
                fill: {
                    opacity: 1
                }
            }
        }
     },
    computed: {
        ...mapState('user', {
            instagram: (state) => state.instagram,
            overviewPeriod:  (state) => state.overviewPeriod
        })
    },
    mounted () {
        this.syncDataFromStorage();
    },
     methods: {
        async changeRange (range) {
            let date = new Date();
            date.setDate(date.getDate() - (range-1));
            if (range !== this.filterDays) {
                await this.$store.dispatch('user/getSocialOverview', {sinceDate: date, platform: 'instagram'});
                this.$store.commit('user/SET_SOCIAL_OVERVIEW_PERIOD', {platform: 'instagram', range });
                this.syncDataFromStorage();
            }
        },
         syncDataFromStorage () {
             this.filterDays = this.overviewPeriod.instagram;
             this.performanceData.forEach((data) => {
                 data.value = this.instagram.overview.performance[data.name].value;
                 if (['average_engagement_rate_per_post'].includes(data.name)) {
                     data.value += '%';
                 }
                 if (this.instagram.overview.performance[data.name].trend) {
                     data.trend = this.instagram.overview.performance[data.name].trend;
                 }
             });

             this.averagePerformanceData.forEach((data) => {
                 data.value = this.instagram.overview.average_performance.average[data.name];
                 const newData = Object.entries(this.instagram.overview.average_performance.daily_performance).map(([key, value]) => {
                     return {
                         x: key,
                         y: value[data.name]
                     }
                 });
                 data.series = [{
                     name: data.label,
                     data: newData
                 }];
             });
         }
     }
};
</script>

<template>
    <div>
        <div class="text-muted text-right last-updated">
            <b-dropdown dropleft variant="info" size="sm">
                <template slot="button-content">
                    <i class="mdi mdi-chevron-left"></i>
                    Last {{ filterDays }} days
                </template>
                <b-dropdown-item-button @click="changeRange(7)">Last 7 days</b-dropdown-item-button>
                <b-dropdown-item-button @click="changeRange(30)">Last 30 days</b-dropdown-item-button>
                <b-dropdown-item-button @click="changeRange(90)">Last 90 days</b-dropdown-item-button>
            </b-dropdown>
        </div>
        <div class="tab-section mt-4 pb-0">
            <h5 class="mb-2 mb-xl-4">Performance</h5>
            <div class="row">
                <div class="col-6 col-lg-3 mb-4 mb-xl-5" v-for="data in performanceData" :key="data.label">
                    <div class="row">
                        <div class="col-12 mb-1 font-size-15">
                            {{ data.label }}
                        </div>
                        <div class="col-12 h-100">
                            <h4 class="mb-0">{{ data.value.toLocaleString() }}
                                <span v-if="data.trend">
                                    <span v-if="data.trend > 0" class="badge text-success mr-2"> + {{ data.trend }}% <i class="mdi mdi-arrow-up"></i></span>
                                <span v-else class="badge text-danger mr-2"> {{ data.trend }}% <i class="mdi mdi-arrow-down"></i></span>
                                </span>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tab-section mt-4">
            <h5 class="mb-2 mb-xl-4">Average performance</h5>
            <div class="row">
                <div class="col-12 col-lg-4" v-for="data in averagePerformanceData" :key="data.label" >
                    <apexchart
                            :ref="data.name"
                            class="apex-charts"
                            type="bar"
                            dir="ltr"
                            height="220"
                            :series="data.series"
                            :options="chartOptions"
                    ></apexchart>
                    <p class="text-center">{{ data.label }}</p>
                    <h4 class="mb-0 text-center">{{ data.value.toLocaleString() }}</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
